var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCme(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.698 12.388c0-.416.09-.786.27-1.11.18-.328.43-.582.75-.762.324-.184.69-.276 1.098-.276.5 0 .928.132 1.284.396s.594.624.714 1.08H7.686a.905.905 0 00-.36-.402.988.988 0 00-.522-.138.98.98 0 00-.768.33c-.196.22-.294.514-.294.882s.098.662.294.882a.98.98 0 00.768.33c.196 0 .37-.046.522-.138a.905.905 0 00.36-.402h1.128c-.12.456-.358.816-.714 1.08-.356.26-.784.39-1.284.39-.408 0-.774-.09-1.098-.27a1.962 1.962 0 01-.75-.762 2.247 2.247 0 01-.27-1.11zm10.072-2.1V14.5h-1.027v-2.526l-.941 2.526h-.829l-.948-2.532V14.5H10v-4.212h1.212l1.182 2.916 1.17-2.916h1.207zm2.32.822v.852h1.374v.792H17.09v.924h1.554v.822h-2.58v-4.212h2.58v.822H17.09z",
    fill: "#fff"
  })));
}
export default SvgCme;